import http from "../../http-common";

class EventRightSideBooksService {
    getEventRightSideBooksService(eventPath: string) {
        return http.get(`/right-side-section/events/books/${eventPath}?topN=2`);
    }
}

export default new EventRightSideBooksService();
